import React from 'react'
import Translation from "../General/Translation"
import TrailerPlayButton from './TrailerPlayButton'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import { setTrailerMovie } from '../actions'

const mapDispatchToProps = (dispatch, ownProps) => ({
    setTrailerMovie: (url) => {
        dispatch(setTrailerMovie(url))
    }
})

const TrailerSmall = ({
    trailerURL, 
    fsk, 
    translation, 
    setTrailerMovie
}) => {
    const trailerMovie = {
        trailerUrl: trailerURL,
        fsk: fsk
    }

    return (
        <div className="trailer-small">
            <div className="trailer-button cursor-pointer" onClick={() => setTrailerMovie(trailerMovie)}>
                <span className="title-large"><Translation id="trailer" trans={translation}>Trailer</Translation></span>
                <TrailerPlayButton/>
            </div>
        </div>
    )
}

export default compose(
    connect(null, mapDispatchToProps),
    toJS()
)(TrailerSmall)